import { ref } from '@nuxtjs/composition-api';
import { StoryblokError } from '~/models/StoryblokError';
import { useStoryblok } from './useStoryblok';

export function useFetchArticle({ articleSlug, categorySlug }) {
  const { storyblok } = useStoryblok();
  const article = ref();

  async function fetchArticle() {
    try {
      const res = await storyblok.getArticle(articleSlug);

      if (res?.content?.topic?.content?.category?.slug !== categorySlug) {
        throw new StoryblokError({ message: 'Article not found', status: 404 });
      }

      article.value = res;
      return res;
    } catch (err) {
      if (err.name === 'StoryblokError') {
        throw err;
      }
      throw new StoryblokError({ message: err.response.statusText, status: err.response.status });
    }
  }

  return {
    article,
    fetchArticle
  };
}
